// 溢出指令提示指令
export default {
  bind (el, binding) {
    // 获取期望的文本行数，默认为1
    const n = binding.value || 1;
    // （1）实现超出n行有省略号
    el.style.display = "-webkit-box";
    el.style.webkitBoxOrient = "vertical";
    el.style.webkitLineClamp = n;
    el.style.overflow = "hidden";
  }
}
